module.exports = __webpack_public_path__ + "static/media/kanye-trump.d2d508d4.png";